/** Display helpers for the Earnings surface (money formatting is shared from
 * the cashbacks formatter; these cover the surface-specific rate and date). */

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

/**
 * Format a margin RATE (a fraction, e.g. 0.325) as a percentage to 1 dp
 * (-> "32.5%"). A null rate (zero commission) renders as "n/a".
 */
export const formatRate = (rate: number | null): string =>
  rate == null ? 'n/a' : `${(rate * 100).toFixed(1)}%`;

/** Short UTC date for a boost end ("2026-01-02..." -> "2 Jan"). */
export const formatShortDate = (iso: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]}`;
};
